import * as Yup from "yup"

const yupPhoneValidate = () => {
  return Yup.string()
    .notOneOf(["+"], "Invalid phone number")
    .min(4, "Invalid phone number")
    .required("Phone number is required")
}
export default yupPhoneValidate
